module.exports = __webpack_public_path__ + "static/media/qualcomm.9562da07.svg";